<scattre-canvas
  (created)="created($event)"
  (changeMaterials)="getMaterials($event)"
  (deleteStickerAttachMeshData)="deleteAttachStickerMeshName($event)"
  (isLoading)="isLoading($event)"
></scattre-canvas>
